import { create } from 'zustand';
import type { Role, User } from '@/types';

interface AuthState {
  user: User | null;
  /** Access token held in memory. Cookie is source of truth; this mirror enables Authorization header if needed. */
  accessToken: string | null;
  isAuthed: boolean;
  isBootstrapping: boolean;

  setUser: (user: User | null) => void;
  setAccessToken: (token: string | null) => void;
  setRole: (role: Role) => void;
  setBootstrapping: (v: boolean) => void;

  reset: () => void;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  accessToken: null,
  isAuthed: false,
  isBootstrapping: true,

  setUser: (user) => set({ user, isAuthed: !!user }),
  setAccessToken: (accessToken) => set({ accessToken }),
  setRole: (role) => {
    const u = get().user;
    if (u) set({ user: { ...u, role } });
  },
  setBootstrapping: (isBootstrapping) => set({ isBootstrapping }),

  reset: () => set({ user: null, accessToken: null, isAuthed: false, isBootstrapping: false }),
}));
